import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from './config.service'
import { Observable } from 'rxjs';
import { Transaction } from '../model/Transaction';

@Injectable({ providedIn: 'root' })
export class TransactionService {
  private baseUrl = this.config.getConfig().ms_transaction + '/transactions';
  private baseUrlContainer = this.config.getConfig().ms_transaction + '/container-types';

  constructor(private http: HttpClient, private config:ConfigService) { }

  getTransactions(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== null) {
          httpParams = httpParams.set(key, params[key]);
        }
      });
    }
    return this.http.get<any>(this.baseUrl, { params: httpParams });
  }

  getContainerTypes(): Observable<any> {
    return this.http.get<any>(this.baseUrlContainer);
  }

  getContainerType(id: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrlContainer}/${id}`);
  }

  createContainerType(data: Partial<any>): Observable<any> {
    return this.http.post<any>(this.baseUrlContainer, data);
  }

  updateContainerType(id: number, data: Partial<any>): Observable<any> {
    return this.http.put<any>(`${this.baseUrlContainer}/${id}`, data);
  }

  deleteContainerType(id: number): Observable<any> {
    return this.http.delete<any>(`${this.baseUrlContainer}/${id}`);
  }

  getTransaction(id: number): Observable<Transaction> {
    return this.http.get<Transaction>(`${this.baseUrl}/${id}`);
  }

  createTransaction(data: Partial<Transaction>): Observable<any> {
    return this.http.post<any>(this.baseUrl, data);
  }

  updateTransaction(id: number, data: Partial<Transaction>): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}/${id}`, data);
  }

  updateTransactionTrans(id: number, data: Partial<Transaction>): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}/${id}/transshipment`, data);
  }

  /** transporte: 'piki7' | 'externo' | 'ninguno'. El backend lo exige. */
  checkoutTransaction(id: number, transporte: string): Observable<any> {
    return this.http.patch<any>(`${this.baseUrl}/${id}/checkout`, { transporte });
  }

  cancelTransaction(id: number): Observable<any> {
    return this.http.patch<any>(`${this.baseUrl}/${id}/cancel`, {});
  }

  calculateAmount(id: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/${id}/calculate-amount`);
  }

  // Reportes
  getActivityReport(params?: any): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/reports/activity`, { params });
  }

  getDetailedActivityReport(params?: any): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/reports/activity-detailed`, { params });
  }

  getRevenueReport(params?: any): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/reports/revenue`, { params });
  }

  getStatusReport(params?: any): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/reports/status`, { params });
  }

  // Reportes de facturación: entradas, salidas y días en patio.
  getGateInReport(params?: any): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/reports/gate-in`, { params });
  }

  getGateOutReport(params?: any): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/reports/gate-out`, { params });
  }

  getStorageDaysReport(params?: any): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/reports/storage-days`, { params });
  }

  getTransportReport(params?: any): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/reports/transport`, { params });
  }
}
